<template>
    <div class="resumo-container">
        <div class="header-section">
            <div class="logo-area logo-left">
                <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid logo-img" />
            </div>
            <div class="title-center">
                Curva de Acompanhamento<br>
                (Previsto x Realizado)
            </div>
            <div class="logo-area logo-right">
                <img v-if="fornecedorLogoUrl" :src="fornecedorLogoUrl" alt="Logo Contratada" class="img-fluid logo-img" />
                <div v-else class="box-placeholder">
                    Logomarca da empresa<br>(consórcio) contratada
                </div>
            </div>
        </div>

        <div class="data-table">
            <div class="table-row">
                <div class="cell left-col">
                    <span class="label">CONTRATO:</span>
                    <span class="value">{{ contrato.codContrato }}</span>
                </div>
                <div class="cell right-col">
                    <span class="label">MEDIÇÃO:</span>
                    <span class="value">{{ boletimMedicao.numero }}</span>
                </div>
            </div>

            <div class="table-row">
                <div class="cell left-col">
                    <span class="label">CONTRATADA:</span>
                    <span class="value">{{ fornecedor }}</span>
                </div>
                <div class="cell right-col">
                    <span class="label">PERÍODO:</span>
                    <span class="value">{{ periodo }}</span>
                </div>
            </div>

            <div class="table-row">
                <div class="cell left-col">
                    <span class="label">ORDEM DE SERVIÇO:</span>
                    <span class="value">{{contrato.ordemServico}}</span>
                </div>
                <div class="cell right-col">
                    <span class="label">VALOR DA MEDIÇÃO (R$):</span>
                    <span class="value">{{ boletimMedicao.total | currency }}</span>
                </div>
            </div>

            <div class="table-row">
                <div class="cell left-col">
                    <span class="label">VIGÊNCIA CONTRATUAL:</span>
                    <span class="value">
                        {{ contrato.inicioVigencia ? $moment(contrato.inicioVigencia).format('DD/MM/YYYY') : '-' }}
                        -
                        {{ contrato.fimVigencia ? $moment(contrato.fimVigencia).format('DD/MM/YYYY') : '-' }}
                    </span>
                </div>
                <div class="cell right-col">
                    <span class="label">VALOR DO CONTRATO (R$):</span>
                    <span class="value">{{ contrato.valorTotal | currency }}</span>
                </div>
            </div>

            <div class="table-row">
                <div class="cell left-col object-cell">
                    <span class="label">OBJETO:</span>
                    <span class="value object-text">{{ contrato.objeto }}</span>
                </div>
                <div class="cell right-col">
                    <span class="label">TOTAL MEDIDO:</span>
                    <span class="value">{{ this.valorTotalTodosBoletins | currency }}</span>
                </div>
            </div>

            <div class="table-row">
                <div class="cell left-col object-continuation">
                </div>
                <div class="cell right-col">
                    <span class="label">SALDO CONTRATUAL (R$):</span>
                    <span class="value">{{ saldoContratualFormatado }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        contrato: {
            type: Object,
            required: true
        },
        boletimMedicao: {
            type: Object,
            required: true
        },
        valorTotalTodosBoletins: {
            type: Number,
            required: false
        },
        fornecedorLogoUrl: {
            type: String,
            default: null
        }
    },

    filters: {
        currency(value) {
            if (value === null || value === undefined || isNaN(value)) return 'R$ 0,00'
            return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    },

    data() {
        return {
            valorTotalBoletinsPersistido: 0,
            logoSuape: '/img/logo.png'
        }
    },

    methods: {
        formatarDataPeriodo(data) {
            if (!data) return ''
            const dataFormatada = this.$moment(data)
            if (!dataFormatada.isValid() || dataFormatada.year() <= 1) return ''
            return dataFormatada.format('DD/MM/YYYY')
        },
    },

    computed: {
        periodo() {
            const inicio = this.formatarDataPeriodo(this.boletimMedicao.dataInicio)
            const fim = this.formatarDataPeriodo(this.boletimMedicao.dataFim)
            if (inicio && fim) return `${inicio} - ${fim}`
            if (inicio) return inicio
            if (fim) return fim
            return this.boletimMedicao.competencia
                ? `${this.$moment(this.boletimMedicao.competencia).startOf('month').format('DD/MM/YYYY')} - ${this.$moment(this.boletimMedicao.competencia).endOf('month').format('DD/MM/YYYY')}`
                : ''
        },
        fornecedor() {
            return this.contrato.fornecedor ? (`${this.contrato.fornecedor.cnpj} - ${this.contrato.fornecedor.nome}`) : '';
        },
        valorTotalBoletinsComputado() {
            if (this.valorTotalTodosBoletins !== undefined && this.valorTotalTodosBoletins !== null) {
                return this.valorTotalTodosBoletins;
            }
            return this.valorTotalBoletinsPersistido;
        },
        chaveLocalStorage() {
            return `valorTotalBoletins_${this.contrato.codContrato}_${this.boletimMedicao.id}`;
        },
        saldoContratualFormatado() {
            const saldo = this.contrato.valorTotal - this.valorTotalBoletinsComputado;
            if (saldo === null || saldo === undefined || isNaN(saldo)) {
                return 'R$ 0,00';
            }
            return Number(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }

    },

    watch: {
        valorTotalTodosBoletins: {
            immediate: true,
            handler(newVal) {
                if (newVal !== undefined && newVal !== null) {
                    localStorage.setItem(this.chaveLocalStorage, newVal.toString());
                    this.valorTotalBoletinsPersistido = newVal;
                }
            }
        }
    },

    mounted() {
        console.log('Contrato Json:', JSON.stringify(this.contrato));
        const valorSalvo = localStorage.getItem(this.chaveLocalStorage);
        if (valorSalvo !== null) {
            this.valorTotalBoletinsPersistido = parseFloat(valorSalvo);
        }
    },
}

</script>

<style scoped>
.resumo-container {
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
    width: 100%;
    background: #fff;
}

.header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 5px;
    min-height: 80px;
}

.logo-area {
    width: 20%;
    display: flex;
    align-items: center;
}

.logo-left {
    justify-content: flex-start;
}

.logo-right {
    justify-content: flex-end;
}

.logo-img {
    max-width: 100%;
    max-height: 100px;
    object-fit: contain;
}

.title-center {
    flex-grow: 1;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
    text-transform: uppercase;
}

.box-placeholder {
    border: 1px solid #000;
    padding: 5px;
    font-weight: bold;
    text-align: center;
    font-size: 0.8rem;
    width: 100%;
}

.data-table {
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
}

.table-row {
    display: flex;
    border-bottom: 1px solid #000;
}

.table-row:last-child {
    border-bottom: none;
}

.table-row:nth-child(5) {
    border-bottom: none;
}

.cell {
    padding: 2px 5px;
    display: flex;
    align-items: center;
    font-size: 0.85rem;
}

.left-col {
    width: 60%;
    border-right: 1px solid #000;
}

.right-col {
    width: 40%;
}

.offset-left {
    margin-left: 60%;
}

.full-width {
    width: 100%;
    align-items: center;
}

.label {
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 5px;
    white-space: nowrap;
}

.value {
    font-weight: 400;
    flex-grow: 1;
}

.object-text {
    white-space: normal;
    line-height: 1.2;
}

.object-cell {
    align-items: flex-start;
}

.object-continuation {
    border-top: none !important;
    padding-top: 0 !important;
}

.table-row:nth-child(5) .right-col {
    border-bottom: 1px solid #000;
}
</style>
